import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import ShipFromWarehouseCustomState from "@thos/Store/Data/ShipFromWarehouse/ShipFromWarehouseState";
import { Draft } from "immer";

const initialState: ShipFromWarehouseCustomState = {};

const reducer = {
    "Custom/ShipFromWarehouse/SetSelectedShipFromWarehouse": (
        draft: Draft<ShipFromWarehouseCustomState>,
        action: { selectedShipFromWarehouse: WarehouseModel }) => {
        draft.selectedShipFromWarehouse = action.selectedShipFromWarehouse;
    },
    "Custom/ShipFromWarehouse/SetCurrentShipFromWarehouse": (
        draft: Draft<ShipFromWarehouseCustomState>,
        action: { currentShipFromWarehouse: WarehouseModel }) => {
        draft.currentShipFromWarehouse = action.currentShipFromWarehouse;
    },
    "Custom/ShipFromWarehouse/SetLoadedShipFromWarehouse": (
        draft: Draft<ShipFromWarehouseCustomState>,
        action: { loadedShipFromWarehouse: WarehouseModel }) => {
        draft.loadedShipFromWarehouse = action.loadedShipFromWarehouse;
    },
    "Custom/ShipFromWarehouse/ChangeCustomerSetSelectedShipFromWarehouse": (
        draft: Draft<ShipFromWarehouseCustomState>,
        action: { changeCustomerSelectedShipFromWarehouse: WarehouseModel }) => {
        draft.changeCustomerSelectedShipFromWarehouse = action.changeCustomerSelectedShipFromWarehouse;
    },
    "Custom/ShipFromWarehouse/ChangeCustomerSetLoadedShipFromWarehouse": (
        draft: Draft<ShipFromWarehouseCustomState>,
        action: { changeCustomerLoadedShipFromWarehouse: WarehouseModel }) => {
        draft.changeCustomerLoadedShipFromWarehouse = action.changeCustomerLoadedShipFromWarehouse;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);